import {Suspense} from 'react'
import {ErrorBoundary} from '@github-ui/react-core/error-boundary'
import {useDevelopmentQuery} from './data/route-queries'
import styles from './Development.module.css'
import {LinkedIssues} from './LinkedIssues'
import {UserSectionSkeleton} from './UserSectionSkeleton'
import sidebarListStyles from './SidebarActionList.module.css'

export function Development() {
  return (
    <ErrorBoundary
      boundaryName="Development"
      fallback={<span className={sidebarListStyles.emptyState}>Unable to load development</span>}
    >
      <Suspense fallback={<UserSectionSkeleton placeholderRows={1} />}>
        <DevelopmentContent />
      </Suspense>
    </ErrorBoundary>
  )
}

function DevelopmentContent() {
  const {data} = useDevelopmentQuery()
  const {linkedIssues} = data

  return linkedIssues.length === 0 ? (
    <span className={sidebarListStyles.emptyState}>No linked issues</span>
  ) : (
    <>
      <span className={styles.helpText}>Successfully merging this pull request may close these issues.</span>
      <LinkedIssues linkedIssues={linkedIssues} />
    </>
  )
}
